import {Component, OnInit} from '@angular/core';
import {NgbModal, NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-spec-warning',
  templateUrl: './spec-warning.component.html',
  styleUrls: ['./spec-warning.component.css']
})
export class SpecWarningComponent implements OnInit {

  constructor(
    private modalService: NgbModal,
    public activeModal: NgbActiveModal,
  ) {
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/common/specializations/components/spec-warning/spec-warning.component.ts